import { __awaiter, __extends, __generator } from "tslib";
import Resource from './resource';
var BusinessModule = (function (_super) {
    __extends(BusinessModule, _super);
    function BusinessModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BusinessModule.prototype.fetchAvailableStates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var states;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.get("/business/states")];
                    case 1:
                        states = (_a.sent()).data.data;
                        return [2, states];
                }
            });
        });
    };
    BusinessModule.prototype.getGeoRegion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var region;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.get('/business/geoip')];
                    case 1:
                        region = (_a.sent()).data.region;
                        return [2, region];
                }
            });
        });
    };
    return BusinessModule;
}(Resource));
export default BusinessModule;
//# sourceMappingURL=business.js.map